// extracted by mini-css-extract-plugin
export default {"container":"SameCustomerList_container__WM9BH","multiple_select_container":"SameCustomerList_multiple_select_container__ylTUi"};